import { testimonials } from '@/mocks/companyData';
import { ASSETS } from '@/constants/assets';

export default function TestimonialsSection() {
  return (
    <section className="relative bg-white py-24 overflow-hidden">
      <div className="px-4 sm:px-6 lg:px-12">
        <div className="flex items-center gap-3 mb-12">
          <div className="w-8 h-[2px] bg-gp-yellow"></div>
          <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Depoimentos</span>
        </div>

        {/* Depoimento 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-gp-yellow"></div>
              <span className="text-gray-500 text-sm uppercase tracking-wider">Verificação de Cliente</span>
            </div>

            <div className="relative mb-8">
              <i className="ri-double-quotes-l text-5xl text-gp-yellow/30 absolute -top-4 -left-2 w-12 h-12 flex items-center justify-center"></i>
              <p className="font-display text-2xl md:text-3xl text-gp-graphite leading-relaxed relative z-10 pl-8">
                {testimonials[0].quote}
              </p>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gp-graphite rounded-full flex items-center justify-center">
                <span className="text-gp-yellow font-display font-bold text-lg">
                  {testimonials[0].author.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div>
                <p className="font-semibold text-gp-graphite">{testimonials[0].author}</p>
                <p className="text-gray-500 text-sm">{testimonials[0].role}, {testimonials[0].company}</p>
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            <img
              src={ASSETS.depoimentos01}
              alt="Depoimento de cliente industrial Pilar - Rômulo"
              className="w-full h-[500px] object-cover rounded-lg"
            />
          </div>
        </div>

        {/* Depoimento 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="lg:order-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-gp-yellow"></div>
              <span className="text-gray-500 text-sm uppercase tracking-wider">Verificação de Cliente</span>
            </div>

            <div className="relative mb-8">
              <i className="ri-double-quotes-l text-5xl text-gp-yellow/30 absolute -top-4 -left-2 w-12 h-12 flex items-center justify-center"></i>
              <p className="font-display text-2xl md:text-3xl text-gp-graphite leading-relaxed relative z-10 pl-8">
                {testimonials[1].quote}
              </p>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gp-graphite rounded-full flex items-center justify-center">
                <span className="text-gp-yellow font-display font-bold text-lg">
                  {testimonials[1].author.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div>
                <p className="font-semibold text-gp-graphite">{testimonials[1].author}</p>
                <p className="text-gray-500 text-sm">{testimonials[1].role}, {testimonials[1].company}</p>
              </div>
            </div>
          </div>

          <div className="hidden lg:block lg:order-1">
            <img
              src={ASSETS.depoimentos02}
              alt="Depoimento de cliente industrial Pilar - William"
              className="w-full h-[500px] object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}